var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { cx } from '@emotion/css';
import React, { forwardRef } from 'react';
import { cssIcon, cssIconWrapper, cssIsCircled } from './css';
export var checkProps = function (_a) {
    var iconName = _a.iconName, isCircled = _a.isCircled;
    if (isCircled && !/-o$/.test(iconName)) {
        throw new Error("Icon " + iconName + " can't be circled");
    }
};
var classNameWrapper = function (_a) {
    var _b;
    var isCircled = _a.isCircled, className = _a.className;
    return cx((_b = {},
        _b[cssIconWrapper] = true,
        _b[cssIsCircled] = isCircled,
        _b), className);
};
var classNameIcon = function (_a) {
    var iconName = _a.iconName, iconClassName = _a.iconClassName;
    return cx(cssIcon, "icon-" + iconName, iconClassName);
};
export var createSvgIcon = function (iconName, viewBox, children) {
    return forwardRef(function (_a, ref) {
        var _b;
        var color = _a.color, isCircled = _a.isCircled, size = _a.size, className = _a.className, iconClassName = _a.iconClassName, style = _a.style, title = _a.title, titleId = _a.titleId, description = _a.description, descriptionId = _a.descriptionId, props = __rest(_a, ["color", "isCircled", "size", "className", "iconClassName", "style", "title", "titleId", "description", "descriptionId"]);
        checkProps({ iconName: iconName, isCircled: isCircled });
        return (React.createElement("span", { className: classNameWrapper({ isCircled: isCircled, className: className }), "aria-hidden": !title && !description, style: __assign(__assign({}, style), { borderColor: color }) },
            React.createElement("svg", __assign({ viewBox: viewBox, role: "img", ref: ref, style: {
                    fill: color,
                    width: size,
                    height: size
                }, "aria-labelledby": cx((_b = {},
                    _b[titleId] = !!titleId,
                    _b[descriptionId] = !!descriptionId,
                    _b)), focusable: "false" }, props, { className: classNameIcon({ iconName: iconName, iconClassName: iconClassName }) }),
                title && React.createElement("title", { id: titleId }, title),
                description && React.createElement("desc", { id: descriptionId }, description),
                children)));
    });
};
